import { render } from "./ClassStudent.vue?vue&type=template&id=b2356b42"
import script from "./ClassStudent.vue?vue&type=script&lang=js"
export * from "./ClassStudent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__